export default __webpack_public_path__ + "static/media/Emotion-Recognition.1935ce4a.jpg";